import { memo } from "react";
import { Badge } from "@/shared/components/ui/badge";
import type {
  CommercialInvoicePaymentMethod,
  CommercialInvoiceStatus,
} from "../types/commercial-invoice.types";

const STATUS_LABEL: Record<CommercialInvoiceStatus, string> = {
  PENDING: "Indefinida",
  ISSUED: "Autorizada",
  ERROR: "Rejeitada",
  CANCELED: "Cancelada",
};

const STATUS_CLASSES: Record<CommercialInvoiceStatus, string> = {
  ISSUED: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  PENDING: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  ERROR: "bg-rose-500/15 text-rose-400 border-rose-500/30",
  CANCELED: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30",
};

const PAYMENT_METHOD_LABEL: Record<CommercialInvoicePaymentMethod, string> = {
  PIX: "PIX",
  CREDIT_CARD: "Crédito",
  DEBIT_CARD: "Débito",
  CASH: "Dinheiro",
};

interface CommercialInvoiceStatusBadgeProps {
  status: CommercialInvoiceStatus;
}

export const CommercialInvoiceStatusBadge = memo(
  function CommercialInvoiceStatusBadge({
    status,
  }: CommercialInvoiceStatusBadgeProps) {
    return (
      <Badge variant="outline" className={STATUS_CLASSES[status]}>
        {STATUS_LABEL[status]}
      </Badge>
    );
  },
);

export const COMMERCIAL_INVOICE_STATUS_LABELS = STATUS_LABEL;

export const COMMERCIAL_INVOICE_PAYMENT_METHOD_LABELS = PAYMENT_METHOD_LABEL;
